/**
 * A Locale provider and context for component strings.
 */
import * as React from "react"
import en_US from "./en_US"
import LocaleContext from "./LocaleContext"
import { mergeDeepRight } from "ramda"

type DeepPartial<T> = { [P in keyof T]?: DeepPartial<T[P]> }

export type LocalAria = {
  ariaLabel: string
  ariaDescription: string
}

type LocaleRequired = React.ContextType<typeof LocaleContext>

type Props = Readonly<{
  locale: DeepPartial<LocaleRequired>
  children?: React.ReactNode
}>

const LocaleProvider = ({ locale, children }: Props) => (
  <LocaleContext.Provider
    value={mergeDeepRight(en_US, locale) as LocaleRequired}
  >
    {children}
  </LocaleContext.Provider>
)

export default LocaleProvider
